module.exports = __webpack_public_path__ + "img/quan.dc399ebb.png";